import api from "./api";

export const getRunnerDRD = async () => {
  return await api.get(`api/domain_runners/drd`);
};